/**
 * @file    lineChartData
 * @scope   SHARED
 * @summary Extracts line-chart series data from a DynamicTable (TanStack columns).
 * @consumes lineChartOptionsBuilder helpers
 * @produces getLineChartData
 * @sideEffects None.
 */
import { LineChartData, TableState } from '../types';
import {
  extractTextFromNode,
  getColumnFieldKey,
  getPercentageFlag,
  getRawColumnByField,
} from './lineChartOptionsBuilder';

const EMPTY: LineChartData = { xData: [], yData: [], percentageFlags: [] };

const getColumnLabel = (rawData: any, col: any, index: number) => {
  const rawDisplayName = getRawColumnByField(rawData, getColumnFieldKey(col))?.displayName;
  if (typeof rawDisplayName === 'string' && rawDisplayName.trim() !== '') {
    return rawDisplayName;
  }
  const label = extractTextFromNode(col?.name ?? col?.header).trim();
  return label || `Column ${index}`;
};

export const getLineChartData = (table?: TableState): LineChartData => {
  if (!table || !table.data || !table.columns || !table.columns[0]) return EMPTY;

  const dataColumns = table.columns.slice(1);
  const firstRow = table.data[0];

  return {
    xData: dataColumns.map((col, idx) => getColumnLabel(table.rawData, col, idx + 1)),
    percentageFlags: dataColumns.map((col) =>
      getPercentageFlag(table.rawData, getColumnFieldKey(col), firstRow)
    ),
    yData: table.data.map((row) =>
      dataColumns.map((col) => {
        const val = row[getColumnFieldKey(col)];
        return typeof val === 'object' && val && 'value' in val ? val.value : val;
      })
    ),
  };
};
